export default class Summary {
    constructor() {
        this.tags = 'h2,h3,h4,h5,h6';
        this.init();
    }

    init() {
            const article = document.querySelector('.article-post');
            const summaryNav = document.querySelectorAll('.summary-nav');
            const summaryBlocks = document.querySelectorAll('.summary-nav ol');

            if (article) {
                const htags = article.querySelectorAll(this.tags);

                if (htags.length < 1) {
                    this.hideSummaryBlocks(summaryNav);
                } else {
                    this.processHeadings(article, htags, summaryBlocks);
                    this.setupObserver(article);
                }
            }
            this.setupSummaryToggle();
            this.setupReferencesToggle();
            if(window.innerWidth > 768) {
                this.sidebarstick();
            }
                
    }

    sidebarstick() {
        const stickyElement = document.getElementById("sticky-summary");
        if (!stickyElement) return;

        const topOffset = 200;
        let stickyOffset = stickyElement.getBoundingClientRect().top + window.scrollY;

        // Armazena a largura original para aplicar quando fixar
        const originalWidth = stickyElement.offsetWidth;

        const onScroll = () => {
            if (window.scrollY >= stickyOffset - topOffset) {
                stickyElement.style.position = "stick";
                stickyElement.style.top = `${topOffset}px`;
                stickyElement.style.zIndex = "7";
                stickyElement.style.width = `${originalWidth}px`; // evita "encolher"
            } else {
                stickyElement.style.position = "";
                stickyElement.style.top = "";
                stickyElement.style.zIndex = "";
                stickyElement.style.width = "";
            }
        };

        // Corrige a posição em resize também
        const onResize = () => {
            stickyOffset = stickyElement.getBoundingClientRect().top + window.scrollY;
            stickyElement.style.width = ""; // reset antes de recalcular
            onScroll(); // atualiza estado
        };

        window.addEventListener("scroll", onScroll);
        window.addEventListener("resize", onResize);
    }


    hideSummaryBlocks(summaryBlocks) {
        summaryBlocks.forEach((summaryBlock) => {
            summaryBlock.style.display = "none";
        });
    }

    processHeadings(article, htags, summaryBlocks) {
        htags.forEach((heading) => {
            if (heading.closest('.block-excerpt')) return;

            const title = heading.innerText.trim();
            const id = heading.id || this.slugify(title);
            const htag = this.slugify(heading.tagName);
            const link = `<li class="${htag}"> <a href="#${id}">${title}</a></li>`;

            heading.id = id;

            summaryBlocks.forEach((summaryBlock) => {
                summaryBlock.insertAdjacentHTML('beforeend', link);
            });
        });
    }

    setupObserver(article) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const id = entry.target.getAttribute('data-id');
                    const link = document.querySelector(`.summary-nav li a[href="#${id}"]`).parentElement;

                    if (entry.isIntersecting && entry.intersectionRatio > 0) {
                        link.classList.add('is-visible');
                    } else {
                        link.classList.remove('is-visible');
                    }
                });

                this.highlightFirstActive();
            },
            { rootMargin: '-100px', threshold: 0.1 }
        );

        this.tags.split(',').forEach((tagName) => {
            const elements = article.querySelectorAll(tagName);

            elements.forEach((element) => {
                const sectionWrap = document.createElement('section');
                sectionWrap.setAttribute('data-id', element.id);
                sectionWrap.setAttribute('class', 'wrap-section');
                sectionWrap.dataset.type = tagName;

                const subordinateElements = this.nextUntil(element, tagName);
                subordinateElements.forEach((subEl) => {
                    sectionWrap.appendChild(subEl);
                });

                observer.observe(sectionWrap);

                element.insertAdjacentElement('beforebegin', sectionWrap);
                sectionWrap.insertAdjacentElement('afterbegin', element);
            });
        });
    }

    setupSummaryToggle() {
        const summaryToggle = document.querySelector('[data-toggle="summary"]');
        const summaryNav = document.querySelector('.summary-nav');

        if (summaryToggle && summaryNav) {
            summaryToggle.addEventListener('click', () => {
                summaryToggle.classList.toggle('actived');
                summaryNav.classList.toggle('show-summary-nav');
            });
        }
    }

    setupReferencesToggle() {
        const referencesToggle = document.querySelector('.references-toggle');
        const referencesContent = document.querySelector('.references-content');
        const referencesChevron = document.querySelector('.references-chevron');
        const referencesSection = document.querySelector('.references-section');

        if (referencesToggle && referencesContent && referencesChevron) {
            referencesToggle.addEventListener('click', function() {
                const isExpanded = referencesSection.classList.contains('is-expanded');
                
                if (isExpanded) {
                    referencesSection.classList.remove('is-expanded');
                    referencesContent.style.maxHeight = '0';
                    referencesChevron.style.transform = 'rotate(0deg)';
                } else {
                    referencesContent.style.maxHeight = 'none';
                    const height = referencesContent.scrollHeight + 'px';
                    referencesContent.style.maxHeight = '0';
                    referencesContent.offsetHeight;
                    referencesSection.classList.add('is-expanded');
                    referencesContent.style.maxHeight = height;
                    referencesChevron.style.transform = 'rotate(180deg)';
                }
            });
        }
    }

    slugify(str) {
        return str
            .toString()
            .normalize('NFKD')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-');
    }

    nextUntil(elem, selector, filter) {
        const siblings = [];
        elem = elem.nextElementSibling;

        while (elem) {
            if (elem.matches(selector)) break;

            if (filter && !elem.matches(filter)) {
                elem = elem.nextElementSibling;
                continue;
            }

            siblings.push(elem);
            elem = elem.nextElementSibling;
        }

        return siblings;
    }

    highlightFirstActive() {
        const summaryBlocks = document.querySelectorAll('.summary-nav ol');
        summaryBlocks.forEach((summaryBlock) => {
            const firstVisibleLink = summaryBlock.querySelector('.is-visible');

            summaryBlock.querySelectorAll('li').forEach((link) => {
                link.classList.remove('active');
            });

            if (firstVisibleLink) {
                firstVisibleLink.classList.add('active');
            }
        });
    }
}

new Summary();